module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00097.cc79b051.jpg";